import * as Sentry from "@sentry/tanstackstart-react";
import { createIsomorphicFn } from "@tanstack/react-start";
import { getHeader } from "@tanstack/react-start/server";
import createClient from "openapi-fetch";
import type { paths } from "./api/api";

export const isomorphicHttpClient = createIsomorphicFn()
  .client(() => {
    const httpClient = createClient<paths>({
      baseUrl: import.meta.env.VITE_PUBLIC_API_URL,
      credentials: "include",
    });

    httpClient.use({
      onResponse: async (response) => {
        if (response.response.status >= 500) {
          Sentry.captureException(
            new Error(`API Error: ${response.response.status} ${response.response.body}`),
          );
        }

        return response.response;
      },
    });

    return httpClient;
  })
  .server(() => {
    const httpClient = createClient<paths>({
      baseUrl: import.meta.env.VITE_PUBLIC_API_URL,
      headers: {
        cookie: getHeader("cookie"),
      },
    });

    httpClient.use({
      onResponse: async (response) => {
        if (response.response.status >= 500) {
          Sentry.captureException(
            new Error(`API Error: ${response.response.status} ${response.response.body}`),
          );
        }

        return response.response;
      },
    });

    return httpClient;
  });
